import React, { PureComponent } from 'react'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
import { TextGeometry } from 'three/addons/geometries/TextGeometry.js';
import { FontLoader } from 'three/addons/loaders/FontLoader.js';
import { CSG } from 'three-csg-ts';
import Drawing from '../Images/2DVisualization.png';
import { CSS2DRenderer, CSS2DObject } from 'three/examples/jsm/renderers/CSS2DRenderer.js';
const CastingBedV = ({elements}) => {
   const RF2=0.01;
    const canvasRef =React.useRef(null);
    const createTextLabel = (text, position) => {
        const div = document.createElement('div');
        div.className = 'label';
        div.textContent = text;
        div.style.marginTop = '-1em';
        const label = new CSS2DObject(div);
        label.position.copy(position);
        return label;
    };
    const createDimensionLine = (start, end) => {
        const material = new THREE.LineBasicMaterial({ color: 0x000000 });
        const points = [start, end];
        const geometry = new THREE.BufferGeometry().setFromPoints(points);
        const line = new THREE.Line(geometry, material);
        return line;
    };

    React.useEffect(() => {
        if (canvasRef.current && canvasRef.current.children.length === 0) {
            // Initialize the scene, camera, and renderer
            const scene = new THREE.Scene();

            const camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000);
           camera.position.set(0, 1, 12);
           scene.position.set(-5,0,0);
            const renderer = new THREE.WebGLRenderer({ antialias: true });
            renderer.setSize(1000, 560);
            renderer.setClearColor(0xffffff, 1.0);



            // Append the renderer DOM element to the canvasRef
            canvasRef.current.appendChild(renderer.domElement);

            // Add axes helper to the scene
            const axesHelper = new THREE.AxesHelper(5);
         //  scene.add(axesHelper);

            // Add a directional light

            // Add a cube and sphere
            let WireGeomtry=new THREE.CylinderGeometry(0.05,0.05,RF2*650,8);


            const cubeMesh = new THREE.Mesh(
                new THREE.BoxGeometry(RF2*1200/6, RF2*600, RF2*250),
                new THREE.MeshPhongMaterial({ color: 'grey' })
            );
            const sphereMesh = new THREE.Mesh(
                new THREE.SphereGeometry(1.45, 8, 8),
                new THREE.MeshPhongMaterial({ color: 0xffff,transparent:true })
            );
             const clynderGeomtry=new THREE.CylinderGeometry(0.8,0.8,RF2*600);
             clynderGeomtry.rotateX=0.5*Math.PI;
             const clynder2Geomtry=new THREE.CylinderGeometry(0.8,0.8,RF2*600);
            const clynder = new THREE.Mesh(
            clynderGeomtry,
            new THREE.MeshPhongMaterial({color:'blue'})
            );
            const clynder2=new THREE.Mesh(
                clynder2Geomtry,
                new THREE.MeshPhongMaterial({color:'red'})
                );
                clynder2.position.set(8,9,5);

            clynder.position.set(4,4,4);
            clynder.rotation.x = 0.5*Math.PI;

            cubeMesh.position.set(RF2*1200,RF2*1200, RF2*1300);
            sphereMesh.position.set(4, 0, 3);
           // scene.add(clynder);
            //scene.add(clynder2);
           // scene.add(cubeMesh);
           // scene.add(sphereMesh);
            const cubeCSG = CSG.fromMesh(cubeMesh, 0)
    const clynderCSG = CSG.fromMesh(clynder, 1)
    const clynder2CSG= CSG.fromMesh(clynder2,2);


    const cubeSphereIntersectCSG = cubeCSG.subtract(clynderCSG).subtract(clynder2CSG);

    for(let i=0;i<6;i++){
            const cubeSphereIntersectMesh = CSG.toMesh(
                cubeSphereIntersectCSG,
                new THREE.Matrix4(),
                [cubeMesh.material, new THREE.MeshPhongMaterial({ color: 'grey',transparent:true }), new THREE.MeshPhongMaterial({ color: 'grey',transparent:true }) ]
            );

            cubeSphereIntersectMesh.position.set(1+(i*1200*RF2)/6,RF2*125, RF2*300)
            cubeSphereIntersectMesh.rotation.x=0.5*Math.PI;
            let Edges = new THREE.EdgesGeometry(clynderGeomtry);
            var edgesMaterial = new THREE.LineBasicMaterial({ color: 0x000000, depthTest: true});
            var Lines = new THREE.LineSegments(Edges, edgesMaterial);
            cubeSphereIntersectMesh.add(Lines);
            scene.add(cubeSphereIntersectMesh);
            const WireCylinder = new THREE.Mesh(
                WireGeomtry,
                new THREE.MeshPhongMaterial({ color: 'black' })
            );
            WireCylinder.position.set(1.75+(i*RF2*1200)/6,RF2*50, RF2*300);
            WireCylinder.rotation.x = 0.5 * Math.PI;
            scene.add(WireCylinder);
}
            const widthPoints = [];
            widthPoints.push( new THREE.Vector3( 0,0 , 700*RF2 ) );
            widthPoints.push( new THREE.Vector3( 1196*RF2, 0,700*RF2 ) );
            const widthEndLinePoints= [new THREE.Vector3( 1196*RF2, 0,750*RF2 ),new THREE.Vector3( 1196*RF2, 0, 600*RF2 )];
            const widthEndLine = createDimensionLine(widthEndLinePoints[0], widthEndLinePoints[1]);
            scene.add(widthEndLine);
            const widthLineStartPoints = [new THREE.Vector3( 0, 0, 750*RF2 ),new THREE.Vector3( 0, 0, 600*RF2 )];
            const widthLineStart = createDimensionLine(widthLineStartPoints[0], widthLineStartPoints[1]);
            scene.add(widthLineStart);
            const widthLine = createDimensionLine(widthPoints[0], widthPoints[1]);
            scene.add(widthLine);
            const DepthStartPoints = [new THREE.Vector3( 1200*RF2, 0, 600*RF2 ),new THREE.Vector3( 1350*RF2, 0, 600*RF2 )];
            const DepthStartLine = createDimensionLine(DepthStartPoints[0], DepthStartPoints[1]);
            scene.add(DepthStartLine);
            const DepthEndPoints = [new THREE.Vector3( 1200*RF2, 0, 0*RF2 ),new THREE.Vector3( 1350*RF2, 0, 0*RF2 )];
            const DepthEndLine = createDimensionLine(DepthEndPoints[0], DepthEndPoints[1]);
            scene.add(DepthEndLine);
            const DepthLinePoints=[new THREE.Vector3( 1300*RF2, 0, 600*RF2 ),new THREE.Vector3( 1300*RF2, 0, 0*RF2 )];
            const DepthLine = createDimensionLine(DepthLinePoints[0], DepthLinePoints[1]);
            scene.add(DepthLine);
            const HeightLinePoints = [ new THREE.Vector3(-0.5,0,300*RF2),new THREE.Vector3(-0.5,250*RF2,300*RF2)];
            const HeightLine = createDimensionLine(...HeightLinePoints);
            scene.add(HeightLine);
            const HeightLineStart = [ new THREE.Vector3(0,0,300*RF2),new THREE.Vector3(-0.75,0,300*RF2)];
            const HeightStartLine = createDimensionLine(...HeightLineStart);
            scene.add(HeightStartLine);
            const HeightLineEnd = [ new THREE.Vector3(0,250*RF2,300*RF2),new THREE.Vector3(-0.75,250*RF2,300*RF2)];
            const HeightEndLine = createDimensionLine(...HeightLineEnd);
            scene.add(HeightEndLine);
            const loader = new FontLoader();

            loader.load( 'https://threejs.org/examples/fonts/helvetiker_regular.typeface.json', function ( font ) {

                const geometry = new TextGeometry( '1196mm', {
                    font: font,
                    size: 0.5,
                    depth: 0.005,

                } );
                const TextMaterial = new THREE.MeshPhongMaterial({ color: 0x000000 });
                const Text = new THREE.Mesh(geometry, TextMaterial);
                Text.position.set( 450*RF2, 0,700*RF2);
                scene.add(Text);
                const geometry2 = new TextGeometry( '600mm', {
                    font: font,
                    size: 0.5,
                    depth: 0.005,

                } );
                const Text2 = new THREE.Mesh(geometry2, TextMaterial);
                Text2.position.set( 1330*RF2, 0, 450*RF2);
                Text2.rotateY(0.5*Math.PI);
                scene.add(Text2);
                const geometry3 = new TextGeometry( '205mm', {
                    font: font,
                    size: 0.5,
                    depth: 0.005,

                } );
                const Text3 = new THREE.Mesh(geometry3, TextMaterial);
                Text3.position.set(-0.5, 0, 250*RF2);
                Text3.rotateZ(0.5*Math.PI);
                scene.add(Text3);
            } );
            const light1 = new THREE.DirectionalLight(0xffffff, 6);
            light1.position.set(0, 0, 5);
            scene.add(light1);
            const light2 = new THREE.DirectionalLight(0xffffff, 6);
            light2.position.set(0, 5, 0);
            scene.add(light2);
            const light3 = new THREE.DirectionalLight(0xffffff, 6);
            light3.position.set(5, 0, 0);
            scene.add(light3);



            // Set up orbit controls
           const orbit = new OrbitControls(camera, renderer.domElement);

            orbit.update();

            // Animation loop
            const animate = () => {
                requestAnimationFrame(animate);
               // orbit.update(); // Update the controls in the animation loop
                renderer.render(scene, camera);
            };
            animate();

            // Handle window resize
            const handleResize = () => {
                camera.aspect = window.innerWidth / window.innerHeight;
                camera.updateProjectionMatrix();
                renderer.setSize(window.innerWidth, window.innerHeight);
            };
            window.addEventListener('resize', handleResize);

            // Clean up on component unmount
            return () => {
                window.removeEventListener('resize', handleResize);
                if (canvasRef.current) {
                    canvasRef.current.removeChild(renderer.domElement);
                }
            };
        }
      }, []);
    const resizeFactor=1000/1200;
    const [remainingWidth,setRemainingWidth]=React.useState(1200);
     React.useEffect(
        ()=>{
            if(elements&&remainingWidth==1200){
                for(let i of elements){

                    setRemainingWidth(prev=>prev-(i[4]/100))
                }
            }
        },[]
     )
    return (
    <>
    <div className='card-body'>
        <h2>Casting Bed Visualization</h2>
        <div style={
            {
                background:'white',
                width:'100%',
                height:'fit-content',
                display:'flex',
                justifyContent:'center',
                alignItems:'center',

                padding:'50px'
            }
        }>

            <div style={{
                outline:'2px solid black',
                width: `${resizeFactor*1200}px`,
                height:`${resizeFactor*205}px`,
                display:'flex',
                justifyContent:'flex-start',


            }}>
            {elements?.length>0&&elements?.map(x=> {

                return (<div
                style={{
                    display:'flex',
                    background:'green',
                    height:`${x[5]*resizeFactor}px`,
                    width:`${(x[4]/100)*resizeFactor}px`,
                    outline:`1px solid black`,
                    justifyContent:'center',
                    alignItems:'center'
                }}
                >
                    <p style={{margin:'auto',
                        writingMode: 'tb-rl',
                        fontWeight: 'bold'
                    }}>{x[0]}</p>
                </div>)})
            }
            <div
             style={{background:'yellow',
                display:'flex',
                width:`100%`,
                alignItems:'center',
                justifyContent:'center',
                fontWeight:'Bold'
             }}
            ><p style={{fontWeight:'bold'}}>Remaining Space</p></div>
            </div>


        </div>
        <div style={
            {
                background:'white',
                flexDirection:'column',
                width:'100%',
                height:'fit-content',
                display:'flex',
                justifyContent:'center',
                alignItems:'center'
            }
        }>
              <div
           style={{

                padding:'10px',
                display:'flex',
                flexDirection:'column',
                justifyContent:'center',
                alignItems:'center'
           }}
           >
                <img src={Drawing} alt='Drawing' style={{width:'600px',height:'400px'}}/>
           </div>
            <div
            ref={canvasRef}

            ></div>

        </div>
      </div>

    </>  );
}

export default CastingBedV;